import Styled from "styled-components";
import { Col } from "react-bootstrap";

const Index = Styled(Col)`
    padding: 1rem!important;
`;

export default Index;
